/* stimulusFetch: 'lazy' */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = [
        'short',
        'full',
        'toggle'
    ];

    toggle(event) {
        event.preventDefault();

        this.shortTarget.classList.toggle('d-none');
        this.fullTarget.classList.toggle('d-none');

        this.toggleTarget.textContent =
            this.shortTarget.classList.contains('d-none')
                ? translations['litigant_request_management.Show less']
                : translations['litigant_request_management.Show more'];
    }
}
